module.exports = __webpack_public_path__ + "img/opet-infographic-03.f7ff9c5b.jpg";